export const ActorName: Record<components['schemas']['ActorEnum'], string> = {
  sender: 'Sender',
  recipient: 'Recipient',
  system: 'System',
}

export const BillStatusName: Record<
  components['schemas']['BillStatusEnum'],
  string
> = {
  prepare: 'Prepare',
  'not-prepare': 'Not prepare',
  pending: 'Pending',
}

export const CallStatusName: Record<
  components['schemas']['CallStatusEnum'],
  string
> = {
  busy: 'Busy',
  canceled: 'Canceled',
  completed: 'Completed',
  failed: 'Failed',
  'in-progress': 'In progress',
  'no-answer': 'No answer',
  queued: 'Queued',
  ringing: 'Ringing',
  'conference-start': 'Conference start',
  'conference-end': 'Conference end',
  'participant-join': 'Participant join',
  'participant-leave': 'Participant leave',
}

export const ContractStatusName: Record<
  components['schemas']['ContractStatusEnum'],
  string
> = {
  draft: 'Draft',
  'awaiting-signature': 'Awaiting signture',
  signed: 'Signed',
}

export const ContractStatusSeverity: Record<
  components['schemas']['ContractStatusEnum'],
  string
> = {
  draft: 'secondary',
  'awaiting-signature': 'warn',
  signed: 'success',
}

export const CrewTypeName: Record<
  components['schemas']['CrewTypeEnum'],
  string
> = {
  subcontractor: 'Subcontractor',
  'field-worker': 'Field worker',
  'office-worker': 'Office worker',
}

export const CrewTypeSeverity: Record<
  components['schemas']['CrewTypeEnum'],
  string
> = {
  subcontractor: 'contrast',
  'field-worker': 'info',
  'office-worker': 'secondary',
}

export const DocumentTypeName: Record<
  components['schemas']['DocumentTypeEnum'],
  string
> = {
  initial: 'Initial',
  clearance: 'Clearance',
}

export const FieldTypeName: Record<
  components['schemas']['FieldTypeEnum'],
  string
> = {
  signature: 'Signature',
  initials: 'Initials',
  'text-single': 'Text',
  'text-multiple': 'Textarea',
  email: 'Email',
  'phone-number': 'Phone number',
  number: 'Number',
  currency: 'Currency',
  percentage: 'Percentage',
  checkbox: 'Checkbox',
  'radio-group': 'Radio group',
  dropdown: 'Drop down',
  'foreign-key': 'Foreign key',
  'date-signed': 'Signed date',
  'date-picker': 'Date picker',
  'signer-name': 'Signer name',
}

export const GenericFieldName: Record<string, Record<string, string>> = {
  manager: {
    adjuster: 'Adjuster',
    customer: 'Customer',
  },
  crm: {
    lead: 'Lead',
  },
}

export const GenericFieldURL: Record<string, Record<string, string>> = {
  manager: {
    adjuster: '/manager/adjusters/',
    customer: '/manager/customers/',
  },
  crm: {
    lead: '/crm/leads/',
  },
}

export const DirectionName: Record<
  components['schemas']['DirectionEnum'],
  string
> = {
  inbound: 'Inbound',
  outbound: 'Outbound',
}

export const EmailDirectionName: Record<
  components['schemas']['DirectionEnum'],
  string
> = {
  inbound: 'Inbound',
  outbound: 'Outbound',
}

export const EmailLoopStatusName: Record<
  components['schemas']['EmailLoopStatusEnum'],
  string
> = {
  active: 'Active',
  inactive: 'Inactive',
  paused: 'Paused',
  completed: 'Completed',
}

export const EmailLoopStatusSeverity: Record<
  components['schemas']['EmailLoopStatusEnum'],
  string
> = {
  active: 'primary',
  inactive: 'contrast',
  paused: 'warn',
  completed: 'info',
}

export const EmailStatusName: Record<
  components['schemas']['NotificationStatusEnum'],
  string
> = {
  bounce: 'Bounce',
  queued: 'Queued',
  sent: 'Sent',
  failed: 'Failed',
  delivered: 'Delivered',
  opened: 'Opened',
  open: 'Open',
  processed: 'Processed',
  dropped: 'Dropped',
  deferred: 'Deferred',
  click: 'Click',
}

export const EmailStatusSeverity: Record<
  components['schemas']['NotificationStatusEnum'],
  string
> = {
  bounce: 'danger',
  queued: 'secondary',
  sent: 'info',
  failed: 'danger',
  delivered: 'success',
  opened: 'success',
  open: 'success',
  processed: 'success',
  dropped: 'danger',
  deferred: 'danger',
  click: 'success',
}

export const FlowHandlerName: Record<
  components['schemas']['FlowHandlerEnum'],
  string
> = {
  browser: 'Browser',
  'ring-1-number': 'Ring 1 number',
  'round-robin': 'Round robin',
  'multiple-numbers': 'Multiple numbers',
}

export const MessageStatusName: Record<
  components['schemas']['MessageStatusEnum'],
  string
> = {
  queued: 'Queued',
  sending: 'Sending',
  sent: 'Sent',
  failed: 'Failed',
  delivered: 'Delivered',
  undelivered: 'Undelivered',
  receiving: 'Receiving',
  received: 'Received',
  accepted: 'Accepted',
  scheduled: 'Scheduled',
  read: 'Read',
  partially_delivered: 'Partially delivered',
  canceled: 'Canceled',
}

export const ModuleName: Record<components['schemas']['ModulesEnum'], string> =
  {
    comms: 'Comms',
    manager: 'Manager',
    crm: 'CRM',
    scheduling: 'Scheduling',
  }

export const ProjectStatusName: Record<
  components['schemas']['ProjectStatusEnum'],
  string
> = {
  cancelled: 'Cancelled',
  completed: 'Completed',
  'in-progress': 'In Progress',
  'legal-department': 'Legal Department',
  pending: 'Pending',
  'approval-finalized': 'Approval Finalized',
  'ready-to-close': 'Ready to Close',
}

export const ProjectStatusSeverity: Record<
  components['schemas']['ProjectStatusEnum'],
  string
> = {
  cancelled: 'contrast',
  completed: 'success',
  'in-progress': 'info',
  'legal-department': 'warn',
  pending: 'secondary',
  'approval-finalized': 'info',
  'ready-to-close': 'success',
}

export const ProjectTypeName: Record<
  components['schemas']['ProjectTypeEnum'],
  string
> = {
  insurance: 'Insurance',
  cash: 'Cash',
}

export const ProjectTypeSeverity: Record<
  components['schemas']['ProjectTypeEnum'],
  string
> = {
  insurance: 'success',
  cash: 'info',
}

export const SignatureTypeName: Record<
  components['schemas']['SignatureTypeEnum'],
  string
> = {
  drawn: 'Drawn',
  typed: 'Typed',
  uploaded: 'Uploaded',
}

export const TemplateTypeName: Record<
  components['schemas']['TemplateTypeEnum'],
  string
> = {
  email: 'Email',
  sms: 'SMS',
}

export const TimeOffReasonName: Record<
  components['schemas']['ReasonEnum'],
  string
> = {
  ooo: 'OOO',
  holiday: 'Holiday',
}

export const TokenMethodName: Record<
  components['schemas']['TokenMethodEnum'],
  string
> = {
  'magic-link': 'Magic link',
  password: 'Password',
  '2fa': '2FA',
  sms: 'SMS',
}

export const TokenStatusName: Record<
  components['schemas']['TokenStatusEnum'],
  string
> = {
  pending: 'Pending',
  used: 'Used',
  expired: 'Expired',
  invalidated: 'Invalidated',
}
